import { BiMessageSquareAdd, BiSolidGame } from "react-icons/bi";
import { BsFillHeartFill, BsFillRocketTakeoffFill } from "react-icons/bs";
import {
  FaChess,
  FaCrown,
  FaDice,
  FaFish,
  FaSmile,
  FaStar,
} from "react-icons/fa";
import {
  GiClick,
  GiJesterHat,
  GiPodiumWinner,
  GiPokerHand,
  GiTigerHead,
} from "react-icons/gi";
import { GoNumber } from "react-icons/go";
import { IoDiamond, IoGiftSharp, IoHome, IoTvSharp } from "react-icons/io5";
import { MdRecommend, MdWhatshot } from "react-icons/md";
import { RiBook3Fill, RiHome2Fill } from "react-icons/ri";
import { TbCherryFilled, TbGridDots, TbPokerChip } from "react-icons/tb";
import promotionStar from "../../../images/Icon/star.webp";
import promotionTV from "../../../images/Icon/TV.webp";

const iconClassName =
  "text-2xl mr-[10px] group-hover:text-main-color w-[22px] h-[22px]";

export const iconFilter = (text, { custom = "" } = {}) => {
  switch (text) {
    case "Home":
      return <IoHome className={`${iconClassName} ${custom}`} />;
    case "AllGames":
      return <TbGridDots className={`${iconClassName} ${custom}`} />;
    case "News":
      return <BiMessageSquareAdd className={`${iconClassName} ${custom}`} />;
    case "Top":
      return <MdWhatshot className={`${iconClassName} ${custom}`} />;
    case "Others":
      return <FaCrown className={`${iconClassName} ${custom}`} />;
    case "Jackpot":
      return <IoDiamond className={`${iconClassName} ${custom}`} />;
    case "Baccarat":
      return <GiPokerHand className={`${iconClassName} ${custom}`} />;
    case "Roulette":
      return <TbPokerChip className={`${iconClassName} ${custom}`} />;
    case "TVBasedGames":
      return <IoTvSharp className={`${iconClassName} ${custom}`} />;
    case "Blackjack":
      return <GiJesterHat className={`${iconClassName} ${custom}`} />;
    case "Megaways":
      return <BiSolidGame className={`${iconClassName} ${custom}`} />;
    case "NumberGames":
      return <GoNumber className={`${iconClassName} ${custom}`} />;
    case "Bonus":
      return <IoGiftSharp className={`${iconClassName} ${custom}`} />;
    case "AllTheBooks":
      return <RiBook3Fill className={`${iconClassName} ${custom}`} />;
    case "InstantWin":
      return (
        <BsFillRocketTakeoffFill className={`${iconClassName} ${custom}`} />
      );
    case "DragonTiger":
      return <GiTigerHead className={`${iconClassName} ${custom}`} />;
    case "Sicbo":
      return <FaDice className={`${iconClassName} ${custom}`} />;
    case "Lobby":
      return <RiHome2Fill className={`${iconClassName} ${custom}`} />;
    case "Slots":
      return <TbCherryFilled className={`${iconClassName} ${custom}`} />;
    case "DropsWins":
      return <GiPodiumWinner className={`${iconClassName} ${custom}`} />;
    case "Table":
      return <FaChess className={`${iconClassName} ${custom}`} />;
    case "Fish":
      return <FaFish className={`${iconClassName} ${custom}`} />;
    case "MyFavorite":
      return <BsFillHeartFill className={`${iconClassName} ${custom}`} />;
    case "ClickedGames":
      return <GiClick className={`${iconClassName} ${custom}`} />;
    case "ExclusiveGame":
      return <MdRecommend className={`${iconClassName} ${custom}`} />;
    default:
      return (
        <FaStar
          className={`${iconClassName} ${custom} text-[#f8d33a] origin-center rotate-12`}
        />
        // <img src={promotionStar} className={`${iconClassName} ${custom}`} />
      );
  }
};
